export const PLACE = 'PLACE';
export const MOVE = 'MOVE';
export const CHANGE_FACING = 'CHANGE_FACING';
export const REPORT = 'REPORT';


// WEBPACK FOOTER //
// ./src/app/constants/ActionTypes.js